<form>
  <mat-form-field class="autocomplete-input">
    <mat-label>Select {{name}}</mat-label>
    <input type="text" placeholder="Pick one" aria-label="{name}" matInput [formControl]="formControl"
      [matAutocomplete]="auto" (focusout)="onFocusOut($event)">
    <mat-autocomplete #auto="matAutocomplete">
      @for (option of filteredOptions | async; track option) {
      <mat-option [value]="option">{{option}}</mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</form>
